import sx from '@styled-system/css';
import styled from '@emotion/styled';
import variant from '@styled-system/variant';
import shouldForwardProp from '@styled-system/should-forward-prop';
import Base, { ButtonProps } from './base';
import { DISABLED_COLOR } from './shared';

type ButtonVariants = 'default' | 'primary' | 'alt' | 'light';

const Link = styled(Base, { shouldForwardProp })<ButtonProps<ButtonVariants>>(
  ({ disabled = false }) =>
    sx({
      borderRadius: 0,
      '&[disabled]': {
        color: DISABLED_COLOR,
        '&:hover': {
          color: DISABLED_COLOR,
        },
        '&:active': {
          color: DISABLED_COLOR,
        },
      },
      ...(disabled && {
        color: DISABLED_COLOR,
        '&:hover': {
          color: DISABLED_COLOR,
        },
        '&:active': {
          color: DISABLED_COLOR,
        },
      }),
    }),
  variant({
    variants: {
      default: {
        color: 'black',
        '&:hover': {
          color: 'gray.2',
        },
        '&:active': {
          color: 'gray.1',
        },
      },
      primary: {
        color: 'indigo.3',
        '&:hover': {
          color: 'indigo.1',
        },
        '&:active': {
          color: 'indigo.1',
        },
      },
      alt: {
        color: 'gray.2',
        '&:hover': {
          color: 'gray.1',
        },
        '&:active': {
          color: 'gray.1',
        },
      },
      light: {
        color: 'gray.7',
        '&:hover': {
          color: 'gray.3',
        },
        '&:active': {
          color: 'gray.2',
        },
      },
    },
  }),
);

Link.defaultProps = {
  variant: 'default',
  size: 'md',
  disabled: false,
};

Link.displayName = 'Monterey(Button.Link)';

export default Link;
